<!-- Date: 27/09/2021 -->
<!-- Purpose: Implement search functions for current school, attended schools and intended school questions as a(n) replacement/optimization of API GET allschools in dropdown options -->
<!-- Also implemented API GET school name from schoolID and fixed logic bugs relevent API PUTs on Save user school information. -->
<!-- FILE NAME                  | PURPOSES                                                                 | FUNCTIONS                                                                              -->
<!-- MySchoolFormComponent.vue  | UIs and logic related handling for search results and dropdown options   | functions in methods sections (logic), Vue Templete (UIs)                              -->
<!-- school.js                  | API calling, storing, canceling as a middleware connecting to Salesforce | searchSchools, searchAttendedSchools, searchIntendedSchools, fetchSchoolIdAndNameById  -->
<!-- SchoolController.php       | Extra schoolId and schoolnamekeyword params as additionals               | Get(Request $request)                                                                  -->

<template>
    <v-row justify="center">
        <v-overlay :value='isScreenLoadingData'>
            <v-progress-circular color="#ea7f1d" :size="50" indeterminate></v-progress-circular>
        </v-overlay>
        <v-row justify='center' no-gutters>
        <v-col cols="12" md="5" lg="4" sm="10">
            <v-form ref="form" class="form-primary-text">
                <v-row style="text-align: left">
                    <v-col class="col-12">
                        <span class="question">Have you ever held a GO Scholarship? *</span>
                        <v-spacer></v-spacer>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12 no-top-padding">
                        <v-radio-group class="text-field-height-26 no-margin" v-model="form.has_had_scholarship" :value="form.has_had_scholarship" :rules="[v=> v != undefined || v != null||'Please make a selection']" row>
                            <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="Yes" :value="1" :style="form.has_had_scholarship == 1 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="No" :value="0" :style="form.has_had_scholarship == 0 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                        </v-radio-group>   
                    </v-col>
                </v-row>
                <v-spacer class="row-space-20"></v-spacer>
                <v-row>
                    <!--     v-model="form.current_school_year"    -->
                    <!--  :rules="notNull"   -->
                    <v-col class="col-12">
                        <v-select
                        :items="currentSchoolYearOptions"
                        item-value="id"
                        item-text="name"
                        v-model="currentSchoolYear"
                        label="What school year are you currently in? *"
                        :rules="notEmpty"
                        outlined
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row v-if="showCurrentPrevSchool">
                    <v-col class="col-12">
                        <v-autocomplete
                            v-model="currentSchool"
                            :items="currentSchoolOptions"
                            :search-input.sync="searchSchools"
                            :rules="notEmptyQuery"
                            @blur="onCurrentSchoolBlurred"
                            v-on:keydown="validateSearchQuery"
                            @paste.prevent
                            label="What is your current school? *"
                            prepend-inner-icon="mdi-magnify"
                            outlined
                            hide-no-data
                            hide-details
                            return-object
                            >
                                <template v-slot:append v-if="isSearchingCurrentSchool">
                                    <v-progress-circular indeterminate></v-progress-circular>
                                </template>
                            </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="showCurrentPrevSchool">
                    <v-col class="col-12">
                        <v-autocomplete
                            ref="attendedSchoolsRef"
                            v-model="selectedAttendedSchools"
                            v-on:keydown="validateSearchQuery"
                            :items="selectedAttendedSchoolsOptions"
                            :search-input.sync="searchAttendedSchool"
                            :rules="notEmptyListQuery" 
                            @blur="onAttendedSchoolsBlurred"
                            @input="onAttendedSchoolsChange"
                            @paste.prevent
                            label="List the schools you've previously attended *"
                            prepend-inner-icon="mdi-magnify"
                            outlined
                            multiple
                            auto-select-first
                            hide-no-data
                            hide-details
                            chips
                            deletable-chips
                            return-object
                            >
                                <template v-slot:append v-if="isSearchingAttendedSchool">
                                    <v-progress-circular indeterminate></v-progress-circular>
                                </template>
                                <template v-slot:item="{ item }">
                                    {{item.text}}
                                </template>
                            </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="showCurrentPrevSchool">
                    <v-col class="col-12 no-top-padding">
                    <div class="helper-text">Please select all your previous primary schools and high schools.</div>              
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12">
                        <v-select
                            :items="ScholarshipTypeList"
                            v-model="ScholarshipType"
                            outlined
                            hide-no-data
                            hide-details
                            :rules="notEmpty"
                            label="Which GO Scholarship would you like to apply for?*"
                            ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-12">
                        <v-autocomplete
                            v-model="intendedSchool"
                            :loader-height="5"
                            :items="intendedSchoolOptions"
                            :search-input.sync="searchIntendedSchool"
                            :rules="notEmptyQuery"
                            v-on:keydown="validateSearchQuery"
                            @blur="onIntendedSchoolsBlurred"
                            @paste.prevent
                            prepend-inner-icon="mdi-magnify"
                            label="Which school would you like your scholarship attached to? *"
                            outlined
                            hide-no-data
                            hide-details
                            return-object
                        >
                            <template v-slot:append v-if="isSearchingIntendedSchool">
                                <v-progress-circular indeterminate></v-progress-circular>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="!showIndependent">
                    <v-col class="col-12 no-top-padding">
                        <div class="helper-text">GO Scholarships are available at schools in the Greater Sydney, Adelaide and Canberra regions.</div>
                    </v-col>
                </v-row>
                <v-row v-if="showIndependent">
                    <v-col class="col-12 no-top-padding">
                        <div class="helper-text">GO Scholarships are available at independent schools that GO partners with. Please select your chosen school from the list above.</div>
                    </v-col>
                </v-row>
                <v-row style="text-align: left" v-if="!showIndependent && !IsPrimary">
                    <v-col class="col-12">
                        <span class="question">Are you able to travel from home into the Sydney, Adelaide or Canberra CBD in less than 100 minutes? *</span>
                        <v-spacer></v-spacer>
                    </v-col>
                </v-row>
                <v-row v-if="!showIndependent && !IsPrimary">
                    <v-col class="col-12 no-top-padding">
                        <v-radio-group class="text-field-height-26 no-margin" v-model="form.within_100minutes_travel" :value="form.within_100minutes_travel" :rules="[v => v != undefined || v != null||'Please make a selection']" row>
                            <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="Yes" :value="1" :style="form.within_100minutes_travel == 1? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <v-radio class="radio-row-margin radio-column-padding" color="#ea7f1d" label="No" :value="0" :style="form.within_100minutes_travel == 0 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                        </v-radio-group>   
                    </v-col>
                </v-row >
                <v-row style="margin-top: 20px" v-if="!showIndependent && !IsPrimary">
                    <v-col class="col-12 no-top-padding">
                        <div class="helper-text">By applying for this scholarship, you agree that you can travel from home into either the Sydney, Adelaide or Canberra CBD in less than 100 minutes. For all GO activities you will need to travel in by 8:30am and travel home the same day after activities have finished.</div>
                    </v-col>
                </v-row>
                <v-row>
                    <!--  v-model="form.intended_school_year"    -->
                    <!--   :rules="[!!form.intended_school_year || 'You have to select a year.', form.intended_school_year - form.current_school_year >= 0 || 'You are applying for a Scholarship for past years, please check and try again.', form.intended_school_year - form.current_school_year === 1 || form.intended_school_year - form.current_school_year === 0|| 'Presently, you may only submit an application for a GO Scholarship 1 year in advance. If you are applying for a Scholarship for future years, please come back the year before and try again.']"   -->
                    <!--  :rules="[!!intendSchoolYear || 'You have to select a year.', calcIntendedRule() >= 0 || 'You are applying for a Scholarship for past years, please check and try again.', calcIntendedRule() === 1 || calcIntendedRule() === 0|| 'Presently, you may only submit an application for a GO Scholarship 1 year in advance. If you are applying for a Scholarship for future years, please come back the year before and try again.']"  -->
                    <!--  :rules="checkintendedyear"  -->
                    <v-col class="col-12">
                        <v-select
                        :items="schoolYearOptions"
                        item-value="id"
                        item-text="name"
                        v-model='intendSchoolYear'
                        label="Which school year is this scholarship intended for? *"
                        :rules="checkintendedyear"
                        
                        outlined
                        @change="setFocusToNextQuestion"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row v-if="this.showSameYearQuestion">
                    <v-col class="col-12">
                        <div>
                            You have entered the same school year in both your current year and your intended scholarship year. Does this mean that you are intending to repeat a year at school?
                            <p style="font-size=11px">If you are applying a scholarship for current year, please select 'No'.</p>
                        </div>
                        <!--  <v-radio-group id="sameYear" v-model="form.repeating_a_year" :value="form.repeating_a_year" :rules="[form.intended_school_year - form.current_school_year === 0 && form.repeating_a_year === 1 || 'Please confirm that you are intending to repeat a year at school. If not, please click on No and change your current year or intended year of scholarship.', v => v != undefined || v != null||'Please make a selection']" row>  -->
                            <v-radio-group id="sameYear" v-model="form.repeating_a_year" :value="form.repeating_a_year" :rules="[v=> v != undefined || v != null||'Please make a selection']" row>
                            <v-radio color="#ea7f1d" label="Yes" :value="1" :style="form.repeating_a_year == 1 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>
                            <v-radio color="#ea7f1d" label="No" :value="0" :style="form.repeating_a_year == 0 ? 'font-weight: bold;': 'font-weight: normal'"></v-radio>    
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-form>
        </v-col>
        </v-row>
    </v-row>
</template>
<script>
import Client from '../../client.js';
import axios from 'axios';

export default {
    data: function() {
        return {
            // Move to backend a 
            //restart use
            schoolYearOptions: [
                  'Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5', 'Year 6', 'Year 7', 'Year 8', 'Year 9', 'Year 10', 'Year 11', 'Year 12'
            ],
            currentSchoolYearOptions: [
                'Kindy/Reception', 'Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5', 'Year 6', 'Year 7', 'Year 8', 'Year 9', 'Year 10', 'Year 11', 'Year 12'
            ],
            currentSchoolYear:'',
            intendSchoolYear:'',
            currentSchool: null,
            currentSchoolOptions: [],
            selectedAttendedSchoolsOptions: [],
            intendedSchoolOptions: [],
            selectedAttendedSchools: [],
            intendedSchool: null,
            ScholarshipTypeList:[],
            ScholarshipType: "",
            ScholarshipTypeSimple: "",
            schoolTextBox: null,
            form: {},
            searchSchools: null,
            searchAttendedSchool: null,
            searchIntendedSchool: null,
            showFirstYearPicker: false,
            showLastYearPicker: false,
            showIndependent: true,
            showCurrentPrevSchool: true,
            //checkIntendedRuleNo: 3,
            IsPrimary: false,
            savedCurrentSchool: null,
            savedSelectedAttendedSchools: [],
            savedSchoolType: "",
            savedIntendedSchool: null,
            isScreenLoadingData: true,
            isSearchingCurrentSchool: false,
            isSearchingAttendedSchool: false,
            isSearchingIntendedSchool: false
        }
    },
    async beforeMount() {

    },
    async mounted() {
        if(this.$parent.childName) this.$parent.childName  = 'MY SCHOOL';

        let client = Client();
        let requests = await axios.all([
            client.get('me/profile'),
            client.get('me/schools'),
            client.get('me/new_schools')
        ]);
        let school_type = requests[0].data.school_type;
        let school_level = requests[0].data.school_level || this.$store.getters['schtype/getschtype']['schooltype'];
        console.log('school_type   ' + school_type + '   school_level   ' + school_level);
        this.form = requests[0].data;
        this.$refs.form && this.$refs.form.resetValidation();

        if (this.form.current_school_id !== null) {
            const currentSchoolOption = await this.$store.dispatch('school/fetchSchoolIdAndNameById', this.form.current_school_id);
            if (currentSchoolOption.value !== undefined && currentSchoolOption.text !== undefined) {
                this.currentSchoolOptions = [currentSchoolOption];
                this.currentSchool = currentSchoolOption;
                this.savedCurrentSchool = currentSchoolOption;
            }
        }

        if(requests[1].data.length > 0) {
            let attendedSchools = requests[1].data.map(s => s.school_id);
            if (attendedSchools.filter(s => s !== '').length > 0) {
                for (let aSchoolId in attendedSchools) {
                    const aSchoolOption = await this.$store.dispatch('school/fetchSchoolIdAndNameById', attendedSchools[aSchoolId]);
                    this.selectedAttendedSchoolsOptions.push(aSchoolOption);
                }
                this.selectedAttendedSchools = attendedSchools;
                this.savedSelectedAttendedSchools = this.selectedAttendedSchoolsOptions;
            }
        }

        if (requests[2].data.school_id.length > 0) {
            const currentIntendedSchool = await this.$store.dispatch('school/fetchSchoolIdAndNameById', requests[2].data.school_id[0].school_id);
            this.intendedSchool = currentIntendedSchool;
            this.intendedSchoolOptions = [currentIntendedSchool];
            this.savedIntendedSchool = currentIntendedSchool;
        }           
        
        this.savedSchoolType = school_type;

        if(school_level == 'primary'){
            this.IsPrimary = true;
            this.ScholarshipTypeList = ['GO-PEF Public Primary School Scholarship','GO Independent Primary School Scholarship'];
            this.schoolYearOptions = [
                  'Kindergarten', 'Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5', 'Year 6'
            ];
            this.currentSchoolYearOptions = [
                'Pre-Kindergarten / Reception','Kindy/Reception', 'Year 1', 'Year 2', 'Year 3', 'Year 4', 'Year 5', 'Year 6'
            ];
            if(school_type && school_type == 'public'){
                this.ScholarshipTypeSimple = 'public';
                this.ScholarshipType = this.ScholarshipTypeList[0];
            }else if(school_type && school_type == 'independent'){
                this.ScholarshipTypeSimple = 'independent';
                this.ScholarshipType = this.ScholarshipTypeList[1];
            }else{
                // first time fill this page
                //this.ScholarshipTypeSimple = 'public';
                //this.$store.commit('schtype/updateData',{key: 'scholarshiptype', data: 'public'});
                //this.form.school_type = 'public';
                //this.ScholarshipType = this.ScholarshipTypeList[0];
                //console.log('load primary public');
            }
        }else if(school_level == 'high'){
            this.IsPrimary = false;
            this.ScholarshipTypeList = ['GO-PEF Public High School Scholarship','GO Independent High School Scholarship'];
            if(requests[2].data.school_type.length == 0) {
                this.ScholarshipTypeSimple = 'public';
                this.ScholarshipType = this.ScholarshipTypeList[0];
                this.showIndependent = false;
                this.intendedSchool = null;
                this.intendedSchoolOptions = [];
            }else{
                this.ScholarshipTypeSimple = requests[2].data.school_type[0].school_type;
                if(this.ScholarshipTypeSimple == 'public'){
                    this.showIndependent = false;
                    this.ScholarshipType = this.ScholarshipTypeList[0];
                }else if(this.ScholarshipTypeSimple == 'independent'){
                    this.showIndependent = true;
                    this.ScholarshipType = this.ScholarshipTypeList[1];
                }
            }
        }

        this.$store.commit('schtype/updateData',{key: 'scholarshiptype', data: this.ScholarshipTypeSimple});

        switch (this.form.current_school_year) {
            case "-1":
                this.currentSchoolYear = 'Pre-Kindergarten / Reception';
                break;
            case "0":
                this.currentSchoolYear = 'Kindy/Reception';
                break;
            case "1":
                this.currentSchoolYear = 'Year 1';
                break;
            case "2":
                this.currentSchoolYear = 'Year 2';
                break;
            case "3":
                this.currentSchoolYear = 'Year 3';
                break;
            case "4":
                this.currentSchoolYear = 'Year 4';
                break;
            case "5":
                this.currentSchoolYear = 'Year 5';
                break;
            case "6":
                this.currentSchoolYear = 'Year 6';
                break;
            case "7":
                this.currentSchoolYear = 'Year 7';
                break;
            case "8":
                this.currentSchoolYear = 'Year 8';
                break;
            case "9":
                this.currentSchoolYear = 'Year 9';
                break;
            case "10":
                this.currentSchoolYear = 'Year 10';
                break;
            case "11":
                this.currentSchoolYear = 'Year 11';
                break;
            case "12":
                this.currentSchoolYear = 'Year 12';
                break;
            default:
        }

        if(this.form.intended_school_year !== null){
            switch (this.form.intended_school_year.toString()) {
            case "0":
                this.intendSchoolYear = 'Kindergarten';
                break;
            case "1":
                this.intendSchoolYear = 'Year 1';
                break;
            case "2":
                this.intendSchoolYear = 'Year 2';
                break;
            case "3":
                this.intendSchoolYear = 'Year 3';
                break;
            case "4":
                this.intendSchoolYear = 'Year 4';
                break;
            case "5":
                this.intendSchoolYear = 'Year 5';
                break;
            case "6":
                this.intendSchoolYear = 'Year 6';
                break;
            case "7":
                this.intendSchoolYear = 'Year 7';
                break;
            case "8":
                this.intendSchoolYear = 'Year 8';
                break;
            case "9":
                this.intendSchoolYear = 'Year 9';
                break;
            case "10":
                this.intendSchoolYear = 'Year 10';
                break;
            case "11":
                this.intendSchoolYear = 'Year 11';
                break;
            case "12":
                this.intendSchoolYear = 'Year 12';
                break;
            default:
            }
        }

        this.isScreenLoadingData = false;
    },
    watch: {
        ScholarshipType: function(){
            if(this.ScholarshipType == this.ScholarshipTypeList[0]){
                this.showIndependent = false;
                if(this.ScholarshipTypeList[0].toLowerCase().includes('primary')){
                    this.$store.commit('schtype/updateData',{key: 'schooltype', data: 'primary'});
                    this.form.school_level = 'primary';
                }else{
                    this.$store.commit('schtype/updateData',{key: 'schooltype', data: 'high'});
                    this.form.school_level = 'high';
                }
                this.ScholarshipTypeSimple = 'public';
                this.$store.commit('schtype/updateData',{key: 'scholarshiptype', data: 'public'});
                this.form.school_type = 'public';
            }else if(this.ScholarshipType == this.ScholarshipTypeList[1]){
                this.showIndependent = true;
                if(this.ScholarshipTypeList[0].toLowerCase().includes('primary')){
                    this.$store.commit('schtype/updateData',{key: 'schooltype', data: 'primary'});
                    this.form.school_level = 'primary';
                }else{
                    this.$store.commit('schtype/updateData',{key: 'schooltype', data: 'high'});
                    this.form.school_level = 'high';
                }
                this.ScholarshipTypeSimple = 'independent';
                this.$store.commit('schtype/updateData',{key: 'scholarshiptype', data: 'independent'});
                this.form.school_type = 'independent';
            }

            if (this.ScholarshipTypeSimple == this.savedSchoolType) {
                this.intendedSchool = this.savedIntendedSchool;
                this.intendedSchoolOptions = [this.savedIntendedSchool];
            } else {
                this.intendedSchool = null;
                this.intendedSchoolOptions = [];
            }
        },
        currentSchool (newValue, oldValue) {
            if (newValue !== oldValue) {
                this.isSearchingCurrentSchool = false;
            }
        },
        selectedAttendedSchools (newValue, oldValue) {
            if (newValue !== oldValue) {
                this.isSearchingAttendedSchool = false;
            }
        },
        intendedSchool (newValue, oldValue) {
            if (newValue !== oldValue) {
                this.isSearchingIntendedSchool = false;
            }            
        },
        searchSchools: function(val) {
            if (!val) {
                this.currentSchool = null
                this.currentSchoolOptions = [];
                return;
            }
            if (val.length < 5) { 
                this.currentSchoolOptions = [];
                return;
            }
            if (this.currentSchool == null || this.currentSchool.text == null) 
                return val && this.querySchools(val);
            val && this.currentSchool.text !== val && this.querySchools(val)
        },
        searchAttendedSchool: function(val) {
            if (!val || val.length < 5) {
                this.$refs.attendedSchoolsRef.isMenuActive = false;
                this.selectedAttendedSchoolsOptions = this.selectedAttendedSchools;
                return;
            }
            val && !this.selectedAttendedSchools.includes(val) && this.queryAttendedSchools(val)
        },
        searchIntendedSchool: function(val) {
            if (!val) {
                this.intendedSchool = null
                this.intendedSchoolOptions = [];
                return;
            }
            if (val.length < 5) { 
                this.intendedSchoolOptions = [];
                return;
            }
            if (this.intendedSchool == null || this.intendedSchool.text == null) 
                return val && this.queryIntendedSchools(val);
            val && this.intendedSchool.text !== val && this.queryIntendedSchools(val)
        },
        currentSchoolYear: function(val) {
        //deal with form.current_school_year
            if(val == 'Pre-Kindergarten / Reception'){
                //hide next 2 questions  and  set defaut value
                this.showCurrentPrevSchool = false;
                this.currentSchool = null;
                this.currentSchoolOptions = [];
                this.selectedAttendedSchools = [];
                this.selectedAttendedSchoolsOptions = [];
            }else{
                this.showCurrentPrevSchool = true;
                if (this.savedCurrentSchool !== null) {
                    this.currentSchoolOptions = [this.savedCurrentSchool];
                    this.currentSchool = this.savedCurrentSchool.value;
                }
                if (this.savedSelectedAttendedSchools.length > 0) {
                    this.selectedAttendedSchoolsOptions = this.savedSelectedAttendedSchools;
                    this.selectedAttendedSchools = this.savedSelectedAttendedSchools;
                }
            }
            this.form.current_school_year = this.currentSchoolYearTrans(val);
            //this.intendSchoolYear = '';

      },
      intendSchoolYear: function(val){
          this.form.intended_school_year = this.intendedSchoolYearTrans(val);
          this.calcIntendedRule();
      },
    },
    computed: {
        notNull() {
            return [
                v => v !== null && v !== undefined 
            ]
        },
        notEmpty() {
            return [
                v => {
                    return v !== null
                        && v !== undefined
                        && JSON.parse(JSON.stringify(v)).length > 0;
                }
            ]
        },
        notEmptyQuery() {
            return [ v => { return v !== null && v !== undefined; } ]
        },
        notEmptyListQuery() {
            return [ v=> { return v.length > 0; } ]
        },
        checkintendedyear() {
            /*
            () => (this.email === this.emailToMatch) || 'E-mail must match',
        v => !!v || 'Confirmation E-mail is required'
            */ 
            //return [!!intendSchoolYear || 'You have to select a year.', 
            //calcIntendedRule() >= 0 || 'You are applying for a Scholarship for past years, please check and try again.', 
            //calcIntendedRule() === 1 || calcIntendedRule() === 0|| 'Presently, you may only submit an application for a GO Scholarship 1 year in advance. If you are applying for a Scholarship for future years, please come back the year before and try again.'];
            //return [v => !v ? !!v || 'The field cannot be empty': v.length >= this.community_min && v.length <= this.community_max || 'Please Shorten your answer into 100 characters']
            /*
            return [
                () => !!this.intendSchoolYear || 'You have to select a year.',
                (this.currentSchoolYear == 'Kindy/Reception' &&  this.intendSchoolYear  == 'Kindergarten') || 'You can\'t select same year for Kindergarten',
                this.calcIntendedRule() >= 0 || 'You are applying for a Scholarship for past years, please check and try again.',
                this.calcIntendedRule() === 1 || this.calcIntendedRule() === 0|| 'Presently, you may only submit an application for a GO Scholarship 1 year in advance. If you are applying for a Scholarship for future years, please come back the year before and try again.'
            ];*/
            if(!this.intendSchoolYear){
                return ['You have to select a year.'];
            }else if(this.currentSchoolYear == 'Kindy/Reception' &&  this.intendSchoolYear  == 'Kindergarten'){
                return ['You can\'t select same year for Kindergarten'];
            }else if(this.calcIntendedRule() < 0){
                return ['You are applying for a Scholarship for past years, please check and try again.'];
            }else if(this.calcIntendedRule() > 1){
                return ['Presently, you may only submit an application for a GO Scholarship 1 year in advance. If you are applying for a Scholarship for future years, please come back the year before and try again.'];
            }else {
                return [true];
            } 

        },
        showSameYearQuestion() {
            return this.form.intended_school_year - this.form.current_school_year === 0 && !!this.form.intended_school_year && !!this.form.current_school_year
        },
        fillin() {
            return this.form.intended_school_year - this.form.current_school_year === 0 && !!this.form.intended_school_year && !!this.form.current_school_year
        },
        /* 11
        [!!form.intended_school_year || 'You have to select a year.', 
        form.intended_school_year - form.current_school_year >= 0 || 'You are applying for a Scholarship for past years, please check and try again.', 
        form.intended_school_year - form.current_school_year === 1 || form.intended_school_year - form.current_school_year === 0|| 
        'Presently, you may only submit an application for a GO Scholarship 1 year in advance. If you are applying for a Scholarship for future years, please come back the year before and try again.']
        
        */ 
    },
    methods: {
        validateSearchQuery(e){
            if(!e.key.match(/^[a-zA-Z' ]*$/)) e.preventDefault();
        },
        querySchools: async function(query) {
            this.isSearchingCurrentSchool = true;
            this.$store.commit('school/cancelSearchSchoolsRequest');
            let isSuccessful = await this.$store.dispatch('school/searchSchools', query);
            this.currentSchoolOptions = this.$store.getters['school/searchSchoolsResults'];
            let searchSchoolCancel = this.$store.getters['school/searchSchoolCancel'];
            if (!searchSchoolCancel || (!isSuccessful && !searchSchoolCancel)) {
                this.isSearchingCurrentSchool = false;
            }
        },
        onCurrentSchoolBlurred: function() {
            this.isSearchingCurrentSchool = false
        },
        onAttendedSchoolsChange: function() {
            this.searchAttendedSchool = null;
            this.selectedAttendedSchoolsOptions = this.selectedAttendedSchools;
            setTimeout(() => {
                this.$refs.attendedSchoolsRef.isMenuActive = false;
            }, 5)
        },
        onAttendedSchoolsBlurred: function() {
            this.isSearchingAttendedSchool = false
        },
        queryAttendedSchools: async function(query) {
            this.isSearchingAttendedSchool = true;
            this.$store.commit('school/cancelSearchAttendedSchoolsRequest');
            let isSuccessful = await this.$store.dispatch('school/searchAttendedSchools', query);
            let searchAttendedSchoolsCancel = this.$store.getters['school/searchAttendedSchoolsCancel'];
            if (!searchAttendedSchoolsCancel || (!isSuccessful && !searchAttendedSchoolsCancel)) {
                this.isSearchingAttendedSchool = false;
            }

            if (this.searchAttendedSchool == null) return;

            this.selectedAttendedSchoolsOptions = this.$store.getters['school/searchAttendedSchoolsResults'];
            for (let aSelectedOption in this.selectedAttendedSchools) {
                if (!this.selectedAttendedSchoolsOptions.includes(this.selectedAttendedSchools[aSelectedOption])) {
                    this.selectedAttendedSchoolsOptions.push(this.selectedAttendedSchools[aSelectedOption]);
                }
            }
        },
        onIntendedSchoolsBlurred: function() {
            this.isSearchingIntendedSchool = false
        },
        queryIntendedSchools: async function(query) {
            this.isSearchingIntendedSchool = true;
            this.$store.commit('school/cancelSearchIntendedSchoolsRequest');
            let level = (this.form.school_level == 'primary') ? '1': '2';
            let type = (this.ScholarshipTypeSimple == 'public') ? '1': '2';
            let isSuccessful = await this.$store.dispatch('school/searchIntendedSchools', {query: query, schoolType: type, schoolLevel: level});
            this.intendedSchoolOptions = this.$store.getters['school/searchIntendedSchoolsResults'];
            let searchIntendedSchoolsCancel = this.$store.getters['school/searchIntendedSchoolsCancel'];
            if (!searchIntendedSchoolsCancel || (!isSuccessful && !searchIntendedSchoolsCancel)) {
                this.isSearchingIntendedSchool = false;
            }
        },
        addSchool: function() {
            this.form.previousSchools.push(this.schoolTextBox);
            this.schoolTextBox = null;
        },
        setFocusToNextQuestion() {

            if(this.showSameYearQuestion){
                setTimeout(() => {
                    const el = document.getElementById('sameYear');
                    el && el.scrollIntoView({behavior: 'smooth'});
                }, 500)
            }

        },
        async submit() {
            let client = Client();

            this.$store.commit('schtype/updateData',{key: 'schoolname', data: this.intendedSchool.text});

            if (this.currentSchool !== null) {
                this.form.current_school_id = this.currentSchool.value;
            } else {
                this.form.current_school_id = null;
            }
            if(!!this.form.repeating_a_year || this.form.repeating_a_year != 1){
                this.form.repeating_a_year = 0;
            }
            if (this.selectedAttendedSchools.length > 0) {
                await client.put('me/schools', this.selectedAttendedSchools.map(s => ({school_id: s.value})))
            } else {
                let schools = [];
                await client.put('me/schools', schools.map(s => ({school_id: s})));
            }
            return await axios.all([
                client.put('me/new_schools', [{school_id: this.intendedSchool.value, school_type: this.$store.getters['schtype/getschtype']['scholarshiptype']}])
            ])
            .then(() => client.patch('me/profile', this.form))
            .catch(error => {
                if(error.response.status === 400) {
                    this.$alert(error.response.data.message)
                }
                return false;
            })
        },
        currentSchoolYearTrans: function(val){
            let tmp = '';
            switch (val) {
            case "Pre-Kindergarten / Reception":
                tmp = -1;
                break;
            case "Kindy/Reception":
                tmp = 0;
                break;
            case "Year 1":
                tmp = 1;
                break;
            case "Year 2":
                tmp = 2;
                break;
            case "Year 3":
                tmp = 3;
                break;
            case "Year 4":
                tmp = 4;
                break;
            case "Year 5":
                tmp = 5;
                break;
            case "Year 6":
                tmp = 6;
                break;
            case "Year 7":
                tmp = 7;
                break;
            case "Year 8":
                tmp = 8;
                break;
            case "Year 9":
                tmp = 9;
                break;
            case "Year 10":
                tmp = 10;
                break;
            case "Year 11":
                tmp = 11;
                break;
            case "Year 12":
                tmp = 12;
                break;
            default:
                //console.log('current_school_year GO into Default');
            }
            return tmp;
        },
        intendedSchoolYearTrans: function(val){
            let tmp = '';
            switch (val) {
            case "Kindergarten":
                tmp = 0;
                break;
            case "Year 1":
                tmp = 1;
                break;
            case "Year 2":
                tmp = 2;
                break;
            case "Year 3":
                tmp = 3;
                break;
            case "Year 4":
                tmp = 4;
                break;
            case "Year 5":
                tmp = 5;
                break;
            case "Year 6":
                tmp = 6;
                break;
            case "Year 7":
                tmp = 7;
                break;
            case "Year 8":
                tmp = 8;
                break;
            case "Year 9":
                tmp = 9;
                break;
            case "Year 10":
                tmp = 10;
                break;
            case "Year 11":
                tmp = 11;
                break;
            case "Year 12":
                tmp = 12;
                break;
            default:
                //console.log('intended_school_year GO into Default');
            }
            return tmp;
        },
        calcIntendedRule: function() {
            return this.intendedSchoolYearTrans(this.intendSchoolYear) - this.currentSchoolYearTrans(this.currentSchoolYear);
        }
    }
}

</script>
<style lang="scss" scoped>
.form-header-padding {
    padding-top: 10px;
}
.add-button {
    color: $go-orange;
    margin-left: 13px;
    font-size: 250%;
    margin-top: 7px;

}
.add-button:hover {
    cursor: pointer;
    color: $go-dark-grey;
}

.row-no-space{
    margin: 0;
}

.helper-text {
  min-height: 30px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #3a3a3a;
}

.form-primary-text{
    font-family: Hind;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: -0.15px;
    color: black
}

.text-field-height{
    height: 56px;
}

.text-field-height-26{
    height: 26px;
}

.row-space-20{
    height: 20px;
}

.no-margin{
    margin:0
}

.no-top-padding{
    padding-top: 0;
}

.question {
    @extend .form-primary-text;
    line-height: 1.44;
    letter-spacing: normal;
}

</style>
